<script>
import Layout from '@layouts/main'
import api from '@utils/api'
import Communications from './communications'
import userHasRolesToWrite from '@utils/userPermissions'

export default {
  name: 'Contact',
  components: { Layout, Communications },
  props: {
    contact: {
      type: Object,
      default: () => {
        return Object
      },
    },
  },
  data() {
    return {
      activaTab: 'mainInformation',
      valid: true,
      loading: false,
      item: {
        id: this.contact.id,
        firstName: this.contact.firstName,
        lastName: this.contact.lastName,
        middleName: this.contact.middleName,
        sex: this.contact.sex,
        description: this.contact.description,
        status: this.contact.status,
      },
      rolesAllowedToWrite: ['SUPERUSER', 'DICTIONARIES_OPERATOR'],
      rules: {
        firstName: [x => !!x || this.$t('validation__is_required')],
        lastName: [x => !!x || this.$t('validation__is_required')],
      },
    }
  },
  computed: {
    status() {
      return this.$store.getters['data/getDictionary']('contactstatus')
      .map(item => {
        item.translatedStatus = this.$t(`contactstatus.${item.code}.name`)
        return item
      })
    },
    sex() {
      return [
        { code: true, name: this.$t('sex.true.name') },
        { code: false, name: this.$t('sex.false.name') },
      ]
    },
    userAllowedToUpdate() {
      return userHasRolesToWrite(
        this.$store.state.auth.userRole,
        this.rolesAllowedToWrite
      )
    },
  },
  methods: {
    close() {
      this.$router.push('/dictionaries/contacts')
    },
    updateContact() {
      if (this.$refs.contactForm.validate()) {
        this.loading = true
        api.updateContact(this.item).then(response => {
          this.$store.dispatch('data/updateDictionary', 'contact')
          this.loading = false
        })
      }
    },
  },
}
</script>

<template>
  <Layout>
    <v-tabs v-model="activaTab">
      <v-tab :href="`#mainInformation`">
        {{ $t('tabs__main_information') }}
      </v-tab>
      <v-tab :href="`#communication`">
        {{ $t('tabs__communication') }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="activaTab">
      <v-tab-item id="mainInformation">
        <v-container fluid>
          <v-layout wrap>
            <v-flex lg4>
              <v-form 
                ref="contactForm" 
                v-model="valid" 
                lazy-validation>
                <v-text-field
                  :label="$t('label__first_name')"
                  :readonly="!userAllowedToUpdate"
                  v-model="item.firstName"
                  :rules="rules.firstName"
                  name="firstName"
                  autocomplete="off"
                  required
                />
                <v-text-field
                  :label="$t('label__last_name')"
                  :readonly="!userAllowedToUpdate"
                  v-model="item.lastName"
                  name="lastName"
                  autocomplete="off"
                  required=""
                />
                <v-text-field
                  :label="$t('label__middle_name')"
                  :readonly="!userAllowedToUpdate"
                  v-model="item.middleName"
                  name="middleName"
                  autocomplete="off"
                />
                <v-select
                  :items="sex"
                  :label="$t('label__sex')"
                  :readonly="!userAllowedToUpdate"
                  v-model="item.sex"
                  item-text="name"
                  item-value="code"
                />
                <v-text-field
                  :label="$t('label__description')"
                  :readonly="!userAllowedToUpdate"
                  v-model="item.description"
                  :rows="2"
                  name="description"
                  autocomplete="off"
                />
                <v-select
                  :items="status"
                  :label="$t('label__status')"
                  :readonly="!userAllowedToUpdate"
                  :rules="rules.status"
                  v-model="item.status"
                  item-text="translatedStatus"
                  item-value="code"
                  required
                />
              </v-form>
              <small>* {{ $t('label__requier_small_text') }}</small>
              <div :class="$style.btnWrapper">
                <v-btn
                  v-if="userAllowedToUpdate"
                  :loading="loading"
                  :disabled="loading"
                  color="success"
                  @click="updateContact"
                >
                  {{ $t('buttons__update') }}
                </v-btn>
                <v-btn 
                  color="secondary" 
                  dark 
                  @click="close">
                  {{ $t('buttons__close') }}
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>
      <v-tab-item id="communication">
        <communications />
      </v-tab-item>
    </v-tabs-items>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.btnWrapper {
  margin-top: 26px;
  margin-left: -8px;
}
</style>
